export const NegotiationDialogStyles = {
  width: '600px',
};
